const convertBlobToBase64 = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(blob);
  });

export function URLToBase64(url) {
  return fetch(url)
    .then((res) => res.blob())
    .then(convertBlobToBase64);
}

export const fileToBase64 = async (file) => {
  const imageURL = URL.createObjectURL(file);
  const imageBase64 = await URLToBase64(imageURL);
  return imageBase64;
};

export const downloadFileFromUrl = (fileUrl, fileName, target='self') => {
  const downloadLink = document.createElement('a');
  downloadLink.href = fileUrl;
  downloadLink.download = fileName;
  downloadLink.target = target;
  downloadLink.click();
};
